module.exports = __webpack_public_path__ + "img/free-icon.5c3f6515.png";